import React, { Component } from "react";

import { Label, FormGroup, Row, Col, Button } from "reactstrap";

import Select, { createFilter } from "react-select";

import { FixedSizeList as List } from "react-window";
import strings from "../../core/translate";
const height = 35;

class MenuList extends Component {
  render() {
    const { options, children, maxHeight, getValue } = this.props;
    const [value] = getValue();
    const initialOffset = options.indexOf(value) * height;

    return (
      <List
        height={maxHeight}
        itemCount={children.length}
        itemSize={height}
        initialScrollOffset={initialOffset}
      >
        {({ index, style }) => <div style={style}>{children[index]}</div>}
      </List>
    );
  }
}

function SelectRow({
  label = "",
  defaultValue,
  datatype = 0, // 0 normal , 1 mouhafaza , 2 kadaa , 3 segel
  name,
  required = false,
  viewonly = false,
  hidelabel = false,
  isMulti = false,
  isSearchable = true,
  readonly = false,
  fastSelect = false,
  placeholder = strings.select,
  data,
  changeInput,
  showAddButton = false, // New prop to toggle the plus button
  onAddClick = () => {}, // New prop for the button click handler
  showDeleteButton = false,
  onDeleteClick = () => {},
}) {
  if (viewonly) {
    readonly = true;
  }

  const isDisabled = viewonly || readonly;
  let useSelect = (
    <Select
      classNamePrefix="react-select"
      name={name}
      isDisabled={isDisabled}
      isMulti={isMulti}
      isSearchable={isSearchable}
      value={data && data.find((v) => v.value === defaultValue)}
      onChange={(e) => changeInput && changeInput(e, name)}
      options={data}
      placeholder={placeholder}
    />
  );

  if (isMulti) {
    useSelect = (
      <Select
        classNamePrefix="react-select"
        name={name}
        isDisabled={isDisabled}
        isMulti={isMulti}
        isSearchable={isSearchable}
        value={defaultValue}
        onChange={(e) => changeInput && changeInput(e, name)}
        options={data}
        placeholder={placeholder}
      />
    );
  }

  if (fastSelect) {
    useSelect = (
      <Select
        classNamePrefix="react-select"
        name={name}
        isDisabled={isDisabled}
        isMulti={isMulti}
        isSearchable={isSearchable}
        filterOption={createFilter({ ignoreAccents: false })}
        value={data && data.find((v) => v.value === defaultValue)}
        onChange={(e) => changeInput && changeInput(e, name)}
        placeholder={placeholder}
        components={{ MenuList }}
        options={data}
      />
    );
  }

  if (hidelabel) {
    return <FormGroup>{useSelect}</FormGroup>;
  }

  if (viewonly) {
    let viewvalue = data && data.find((v) => v.value === defaultValue);
    if (viewvalue) {
      viewvalue = viewvalue.value;
    } else {
      return "";
    }
    return (
      <Row>
        <Label sm="2">{label}</Label>
        <Col
          sm="7"
          style={{
            textAlign: "right",
            padding: 10,
          }}
        >
          <FormGroup>
            <b>{viewvalue}</b>
          </FormGroup>

          {required && (
            <Col className="label-on-right" tag="label" sm="3">
              <code>required</code>
            </Col>
          )}
        </Col>
      </Row>
    );
  }

  return (
    <Row>
      {showDeleteButton && (
        <>
          <center>
            <Button
              color="danger"
              size="sm"
              onClick={onDeleteClick}
              style={{
                marginTop: "10px",
                marginLeft: "50px",
                borderRadius: "10%",
                width: "20px",
                height: "20px",
                padding: "0",
              }}
              title="Delete Row"
            >
              <i className="fa fa-trash" />
            </Button>
          </center>
        </>
      )}
      <Label sm="2" style={{ display: "flex", alignItems: "center" }}>
        {label}
      </Label>
      <Col sm="7">
        <FormGroup>{useSelect}</FormGroup>
      </Col>
      {showAddButton && (
        <>
          <center>
            <Button
              color="success"
              size="sm"
              onClick={onAddClick}
              style={{
                marginTop: "10px",
                marginLeft: "10px",
                marginRight: "20px",
                borderRadius: "10%",
                width: "20px",
                height: "20px",
                padding: "0",
              }}
              title="Add"
            >
              <i className="fa fa-plus" />
            </Button>
          </center>
        </>
      )}

      {required && (
        <Col className="label-on-right" tag="label" sm="3">
          <code>required</code>
        </Col>
      )}
    </Row>
  );
}

export default SelectRow;
